import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface UploadFileRequest {
  file: File;
  appraisalId: string;
  documentObtainedDate: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppraisalFilesService {
  private readonly API_URL = `${environment.apiUrl}/es/AppraisalFiles`;

  constructor(private http: HttpClient) {}

  /**
   * Upload a file to the appraisal files endpoint
   */
  uploadFile(request: UploadFileRequest): Observable<any> {
    const formData = new FormData();
    formData.append('File', request.file, request.file.name);
    formData.append('appraisalId', request.appraisalId);
    formData.append('appraisalDocumentType', '0');
    formData.append('isPrintable', 'false');
    formData.append('documentObtainedDate', request.documentObtainedDate);
    formData.append('fileType', '0');

    return this.http.post(this.API_URL, formData);
  }
}
